angular.module 'zc.master'

.directive 'zcLabelUserAgency', ($state, Devise) ->
  directive =
    restrict: "EA"
    scope: {
      user: '='
    }
    template: '''
    <span
      class="label label-warning"
      ng-if="user.agency_id">
      {{user.agency.title}}
    </span>
    '''

  directive





// WEBPACK FOOTER //
// ./src/master_admin_modules/master/directives/label_user_agency.directive.coffee